import React, {} from 'react';
import Popup from "reactjs-popup";
import FindPositionAlignView from "../multipleFind/FindPositionAlignView";

const PositionAlignDialog_Popup = ({_WaveformView}) => {
//網址判斷
//     useEffect(() => {
//
//     }, [location]);

    return <Popup
        open={_WaveformView.state.isPositionAlignDialog}
        modal
        closeOnDocumentClick
        onClose={()=>{
            _WaveformView.setState({isPositionAlignDialog:false});
        }}
        contentStyle={{width:'450px'  }}
    >
        <FindPositionAlignView showList={()=>{
            _WaveformView.setState({isShowFindPositionList:true});
            _WaveformView.setState({isPositionAlignDialog:false});
            _WaveformView.isShowTranslationsNavbarAlert(false);
        }}/>
    </Popup>;
};

export default PositionAlignDialog_Popup;



// WEBPACK FOOTER //
// ./src/components/popup/PositionAlignDialog_Popup.js